// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5a086b75","455":"0cc415e3","977":"ba65591f"}[chunkId] + ".chunk.js";
};